var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 4.35968C19.0001 6.21517 17.4959 7.71935 15.6404 7.71935C13.7849 7.71935 12.2808 6.21517 12.2808 4.35968C12.2808 2.50418 13.7849 1 15.6404 1C17.4959 1 19.0001 2.50418 19.0001 4.35968Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71935 4.35968C7.71935 6.21517 6.21517 7.71935 4.35968 7.71935C2.50418 7.71935 1 6.21517 1 4.35968C1 2.50418 2.50418 1 4.35968 1C6.21517 1 7.71935 2.50418 7.71935 4.35968Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 15.6403C19.0001 17.4958 17.4959 19 15.6404 19C13.7849 19 12.2808 17.4958 12.2808 15.6403C12.2808 13.7848 13.7849 12.2806 15.6404 12.2806C17.4959 12.2806 19.0001 13.7848 19.0001 15.6403Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71935 15.6403C7.71935 17.4958 6.21517 19 4.35968 19C2.50418 19 1 17.4958 1 15.6403C1 13.7848 2.50418 12.2806 4.35968 12.2806C6.21517 12.2806 7.71935 13.7848 7.71935 15.6403Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.c912d68f.svg";
export { ForwardRef as ReactComponent };